
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#C3AFA3"}},[_c('circle',{attrs:{"cx":"9","cy":"9","r":"3"}}),_c('path',{attrs:{"d":"M17.25 8.25h-1.217a.375.375 0 01-.37-.316 6.763 6.763 0 00-5.597-5.597.375.375 0 01-.316-.37V.75a.75.75 0 00-1.5 0v1.217c0 .184-.134.34-.316.37a6.763 6.763 0 00-5.597 5.597.375.375 0 01-.37.316H.75a.75.75 0 000 1.5h1.217c.184 0 .34.134.37.316a6.763 6.763 0 005.597 5.597c.182.03.316.186.316.37v1.217a.75.75 0 101.5 0v-1.217c0-.184.134-.34.316-.37a6.763 6.763 0 005.597-5.597.375.375 0 01.37-.316h1.217a.75.75 0 100-1.5zm-8.25 6a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5z"}})])])
          )
        }
      }
    